import { useContext, useEffect, useState } from "react";
import ProgressBar from "../progress/progressBar";
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, DialogActions, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { DirectionContext } from "../../context/DirectionProvider";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import jsondata from "../../config/NewEmployerFormFields.json";
import EmployerInput from "./employer-input";
import IdentifiersView from "../detail-page/input/identifiers-view";
import api from "../../service/api";
import useLocalStorage from "../../hooks/useLocalStorage";
import filter from "../../service/filter";
import lovBoundedData from "./lov-bounded.json";
import Storage from "../../session/storage";
import CONSTANT from "../../Constant/Constant";
import NewRelation from "../detail-page/input/relation";
import { Add } from "@mui/icons-material";
import moment from "moment";
import PopupConfimation from "../new-hco/PopupConfirmation";
import popUpMessage from "../../config/popUpMsg.json";
import EmployerConfig from "../../config/EmployerPopupConfig.json";

const AddNewEmployerForm = (props) => {
    // var requirefields = [];
    const direction = useContext(DirectionContext);
    const { country, classificationCode, openPopup } = props;

    const [EmpRequest, setEmpRequest] = useState(classificationCode?.entity_type === 'HCP' ? CONSTANT.NEW_EMP_HCP_BODY : CONSTANT.NEW_EMP_HCO_BODY);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState();
    const [showAllData, setShowAllData] = useState(true);
    const [configData] = useState(jsondata);
    const [formFields, setFormFields] = useState(null);
    const [accordianFlag, setAccordianFlag] = useState({
        mainInfo: true,
        contactInfo: true,
        addressInfo: true,
        relationInfo: true,
    });
    const [formConfig, setFormConfig] = useState(configData?.countries?.find((item) => item?.country_name === country[0])?.[classificationCode?.form_fields_key] || {})
    const [langLocaleChange] = useLocalStorage('wglang_api')
    const [newSource, setNewSource] = useState('')
    const [originalSource, setOriginalSource] = useState('')
    const [noIdentifierData, setNoIdentifierData] = useState(false)
    const [identifierSubmit, setIdentifierSubmit] = useState(false)
    const [optionalRelation, setOptionalRelation] = useState("Not Set");
    const [showRelation, setShowRelation] = useState(false);
    const [relationError, setRelationError] = useState(false);
    const [address, setAddress] = useState(false);
    const [validRequest, setValidRequest] = useState();
    const [clear, setClear] = useState(false);
    const [showError, setShowError] = useState(false);
    const [modal, setModal] = useState({ flag: false });
    const [error, setError] = useState(false);
    const [popMsg] = useState(popUpMessage.newEmployer);
    const [requirefields, setRequireFields] = useState([])
    const [invalidInput, setInvalidInput] = useState({})

    useEffect(() => {
        getFormFields();
    }, [])

    useEffect(() => {
        handleFunction();
    }, [langLocaleChange])

    const handleFunction = () => {
        let receivedResponse;
        setLoading(true)
        api.getPickList(country?.[0], null, null, classificationCode?.entity_type, undefined, langLocaleChange, true).then((res) => {
            // let source = ''
            // if (getPaylodCountry?.key?.payloadKey == 'United States' || location.state.country == 'United States') {
            Storage.setLovBoundedList(filter.mapVnPickList(lovBoundedData[0]))
            // } else {
            //     Storage.setLovBoundedList(filter.mapPickList(res.data[0]))
            //     setDropdownValue(filter.mapPickList(res.data[0]))
            // }
            // if (!location.state.source) {
            //     if (location.state?.country == "United States") {
            //         receivedResponse = source = "VNDR-VN"
            //     }
            //     else {
            //         receivedResponse = source = res.data[0]['source'][0]
            //         setNewSource(source)
            //         countryDataFetch(source);
            //         setOriginalSource(source)
            //     }

            // }
            // else {
            // receivedResponse = source = res.data[0]['source'][0]
            setNewSource('Employer')
            setOriginalSource('Employer')
            // }
            // setShowModal(false)
            setLoading(false)
            // setShowAllData(true)
        }).catch((error) => {
            // let errorDetail = error;
            // let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
            // setErrorMsg(msg ? msg : 'Internal Server Error!');
            setLoading(false)
        })
        let country_code_value = country?.[0]
        // let classification_code_value = classificationCode?.value
        let classification_code_payload = configData?.countries?.find((item) => item?.country_name === country[0])?.[classificationCode?.form_fields_key]?.classification_code_for_payload
        updateValue({ value: country_code_value }, false, "CountryCode");
        updateValue({ value: country_code_value }, false, "Country");
        updateValue({ value: classification_code_payload }, false, "ClassificationCode");
        window.scroll(0, 0)
    }

    const goBack = () => props.history.push("/");

    const getFormFields = () => {
        const country_fields = configData?.countries?.find((item) => item?.country_name === country[0])
        const classification_code_fields = country_fields?.[classificationCode?.form_fields_key]?.input_fields
        setFormConfig(country_fields?.[classificationCode?.form_fields_key])
        setFormFields(classification_code_fields)
        if (classification_code_fields) {
            let requireFieldsTemp = [];
            classification_code_fields.forEach((group_fields) => {
                group_fields?.['attributes']?.map((field) => {
                    if (field.required) {
                        requireFieldsTemp.push(field.id)
                    }
                })
            })

            setRequireFields(requireFieldsTemp)
        }
    }

    const closeAccordian = (id) => {
        setAccordianFlag((prev) => {
            return { ...prev, [id]: !prev[id] }
        })
    }

    const checkIdentifierSubmitted = (addflag, identifierType, identifierId, identifierSaved) => {
        if (addflag && (((identifierType?.length == 0) && (identifierId?.length == 0)) || ((identifierType == undefined) && (identifierId == undefined))) && identifierSaved == false) {
            setNoIdentifierData(true)
            setIdentifierSubmit(false)
        } else if (addflag && identifierType?.length > 0 && identifierId?.length > 0 && identifierSaved == false) {
            setIdentifierSubmit(true)
            setNoIdentifierData(false)
        } else {
            setIdentifierSubmit(false)
            setNoIdentifierData(false)
        }
    }

    const getRelationshipGroupTypeCode = (sourceClassificationCode, relationClassificationCode) => {
        console.log(sourceClassificationCode, relationClassificationCode)
        if((sourceClassificationCode === 'Employer' && relationClassificationCode === 'Broker Office') || (sourceClassificationCode === 'Employer' && relationClassificationCode === 'BROKER_OFFICE'))
            return 'HCOtoHCO_bo'
        else if((sourceClassificationCode === 'Employer Contact' && relationClassificationCode === 'Employer')  || (sourceClassificationCode === 'Employer Contact' && relationClassificationCode === 'E'))
            return 'HCPtoHCO_e'
        else if((sourceClassificationCode === 'Broker Office' && relationClassificationCode === 'Broker') || (sourceClassificationCode === 'Broker Office' && relationClassificationCode === 'BROKER'))
            return 'HCOtoHCO_b'
        else if((sourceClassificationCode === 'Broker Contact' && relationClassificationCode === 'Broker Office') || (sourceClassificationCode === 'Broker Contact' && relationClassificationCode === 'BROKER_OFFICE'))
            return 'HCPtoHCO_bo'
        else if((sourceClassificationCode === 'Broker Contact' && relationClassificationCode === 'Broker') || (sourceClassificationCode === 'Broker Contact' && relationClassificationCode === 'BROKER'))
            return 'HCPtoHCO_b'
        else
            return ''
    }

    const updateValue = (newValue, flag, attribute) => {
        console.group('>>>>>>>>>>>>>>>>>>>>>>>> UPDATED VALES <<<<<<<<<<<<<<<<<<')
        console.log('newValue', newValue)
        console.log('flag', flag)
        console.log('attribute', attribute)
        console.groupEnd()
        if (!!newValue && attribute != 'Relation' && attribute != "Identifiers") {
            Object.keys(newValue).forEach(k => {
                if (typeof newValue[k] === 'string')
                    newValue[k] = newValue[k].trim();
            });
        }

        if (attribute === 'CountryCode') {
            if (newValue.value !== null && formConfig?.isRelationMandatory) {
                setRequireFields((old) => [...old, 'Relation'])
                setOptionalRelation('Required');
                setAddress(false);
                setShowRelation(true);
            } else if (newValue.value !== null && !formConfig?.isRelationMandatory) {
                setOptionalRelation('Optional');
                setRelationError(false);
                setAddress(true);
                setShowRelation(false);
            } else {
                setOptionalRelation('Not Set');
                setEmpRequest((oldvalue) => ({
                    ...oldvalue,
                    entity: {
                        ...oldvalue.entity,
                        Address: undefined
                    }
                }))
                setAddress(false);
                setShowRelation(false);
                delete EmpRequest.relations;
                delete EmpRequest.entity.Address;
            }

        }

        if (attribute !== 'Relation') {
            if (attribute === "Identifiers") {
                if (EmpRequest && EmpRequest["entity"]) {
                    setEmpRequest((oldValue) => ({
                        ...oldValue,
                        entity: {
                            ...oldValue.entity,
                            NewIdentifiers: newValue
                        }
                    }));
                }
            }
            else {
                if (attribute.split('.')[0] === 'Address') {
                    if (EmpRequest.entity.Address !== undefined) {
                        setEmpRequest((oldvalue) => ({
                            ...oldvalue,
                            entity: {
                                ...oldvalue.entity,
                                Address: [{
                                    ...oldvalue.entity.Address[0],
                                    [attribute.split('.')[1]]: [newValue],
                                    Country: [{ value: country?.[0] }],
                                    Rank: [{ value: '1' }],
                                    EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                                    EffectiveEndDate: [{ value: "9999-12-31" }]
                                }]
                            }
                        }))
                    }
                    else {
                        setEmpRequest((oldvalue) => ({
                            ...oldvalue,
                            entity: {
                                ...oldvalue.entity,
                                Address: [{
                                    [attribute.split('.')[1]]: [newValue]
                                }]
                            }
                        }))
                    }
                } else {
                    setEmpRequest((oldvalue) => ({
                        ...oldvalue,
                        entity: {
                            ...oldvalue.entity,
                            [attribute]: [newValue]
                        }
                    }))
                }
            }
        } else {
            if (newValue === undefined) {
                setEmpRequest((oldValue) => {
                    return {
                        ...oldValue,
                        relations: []
                    }
                });
            } else {
                if (newValue.Country === undefined) {
                    setEmpRequest((oldValue) => ({
                        ...oldValue,
                        relations: [
                            {
                                uri: newValue?.HCO?._id,
                                type: newValue?.HCO?._source?.type,
                                label: newValue?.HCO?._source?.label,
                                EffectiveStartDate: [
                                    {
                                        value: moment
                                            .utc(new Date())
                                            .format("YYYY-MM-DD"),
                                    },
                                ],
                                IsNew: true,
                                EffectiveEndDate: [{ value: "9999-12-31" }],
                                Rank: newValue.Rank
                                    ? newValue.Rank
                                    : [{ value: "99" }],
                                Source: newValue?.HCO?._source?.Source,
                                DepartmentIndicator:
                                    newValue?.HCO?._source?.DepartmentIndicator,
                                IsPrimary:
                                    newValue.Rank &&
                                        newValue.Rank[0].value == 1
                                        ? true
                                        : false,
                                relationTypeCode: newValue?.Affiliations ? newValue?.Affiliations[0]?.value : undefined,
                                relationshipGroupTypeCode: getRelationshipGroupTypeCode(classificationCode?.value, newValue?.HCO?._source?.ClassificationCode?.[0]?.value)
                            },
                        ],
                    }));
                } else {
                    const { AddressLine1, City, Zip, StateProvince, Country, ClassificationCode } = newValue;
                    setEmpRequest((oldValue) => ({
                        ...oldValue,
                        relations: [
                            {
                                Country,
                                ClassificationCode,
                                Name: newValue.HCO,
                                ActiveFlag: [{ value: "Y" }],
                                Address: [
                                    {
                                        AddressLine1,
                                        City,
                                        Zip,
                                        StateProvince,
                                        Country,
                                        EffectiveStartDate: [
                                            {
                                                value: moment
                                                    .utc(new Date())
                                                    .format("YYYY-MM-DD"),
                                            },
                                        ],
                                        EffectiveEndDate: [{ value: "9999-12-31" }],
                                        Rank: [{ value: "1" }],
                                    },
                                ],
                                EffectiveStartDate: [
                                    {
                                        value: moment
                                            .utc(new Date())
                                            .format("YYYY-MM-DD"),
                                    },
                                ],
                                EffectiveEndDate: [{ value: "9999-12-31" }],
                                Rank: newValue.Rank
                                    ? newValue.Rank
                                    : [{ value: "99" }],
                                Source: [{ value: newSource }],
                                IsNew: true,
                                IsPrimary:
                                    newValue.Rank &&
                                        newValue.Rank[0].value == 1
                                        ? true
                                        : false,
                                relationTypeCode: newValue?.Affiliations ? newValue?.Affiliations[0]?.value : undefined,
                                relationshipGroupTypeCode: getRelationshipGroupTypeCode(classificationCode?.value, ClassificationCode?.[0]?.value)
                            },
                        ],
                    }));
                }
            }
        }

        if (attribute.split('.')[0] === 'Address') {
            let allAddressFlag = false;
            CONSTANT.EMP_ADDRESS_ATTRIBUTE.forEach((value) => {
                let addresValue = EmpRequest.entity.Address ? EmpRequest.entity.Address[0] : undefined;
                if (attribute.split('.')[1] !== value) {
                    allAddressFlag = allAddressFlag ||
                        !(addresValue && addresValue[value] !== undefined && addresValue[value][0].value.length !== 0);
                } else {
                    allAddressFlag = allAddressFlag || !(newValue.value.length !== 0);
                }
            })

            // if(newValue !== undefined && newValue.value){

            setValidRequest((old) => ({
                ...old,
                Address: allAddressFlag,
                [attribute]: flag
            }))
        } else {
            setValidRequest((old) => ({
                ...old,
                [attribute]: flag
            }))
        }
    }

    const addOptional = (attribute) => {
        if (attribute === 'Relation') {
            setValidRequest((oldvalue) => ({ ...oldvalue, Relation: true }));
        } else {
            setValidRequest((oldvalue) => ({ ...oldvalue, Address: true }));
        }
    }

    const setCancel = (attribute) => {
        if (attribute === 'Relation') {
            setValidRequest((oldvalue) => ({ ...oldvalue, Relation: false }))
            EmpRequest.relations = [];
        } else {
            setValidRequest((oldvalue) => ({ ...oldvalue, Address: false }))
            delete EmpRequest.entity.Address;
        }
    }

    const submitRequest = () => {
        let isValid = true;

        if (EmpRequest === undefined || validRequest === undefined) {
            setError(true);
            setModal(true);
        } else if(Object.keys(invalidInput).length > 0){
            setModal({
                flag: true,
                success: false,
                message: `Please correct the following fields before submitting: ${Object.keys(invalidInput).join(', ')}`,
                title: 'Error'
            });
        } else if (noIdentifierData) {
            setModal({
                flag: true,
                success: false,
                message: 'Please enter data into the Identifier fields before Submitting Request!',
                title: 'Error'
            });
        } else if (identifierSubmit) {
            setModal({
                flag: true,
                success: false,
                message: 'Please save the identifiers before submitting the request',
                title: 'Error'
            });
        } else {
            let errorFlag = false;
            console.log('requirefields', requirefields)
            requirefields.forEach((id) => {
                let value = validRequest[id];
                console.group()
                console.log(id)
                console.log(showRelation)

                if ((id === 'Relation') && !showRelation) {
                    console.log('Relation is not shown', showRelation);
                    errorFlag = errorFlag || false;
                    setRelationError(false);
                } else if ((id === 'Address') && !address) {
                    console.log('Address is not shown', address);
                    errorFlag = errorFlag || false;
                    setRelationError(false);
                }
                else {
                    if (value === undefined || value === true) {
                        errorFlag = errorFlag || true;
                        setRelationError(true);
                        isValid = false;
                    }
                }
            });
            console.log(errorFlag, isValid)
            setError(errorFlag);
            setRelationError(true && showRelation && errorFlag);
            if (isValid) {
                setModal({
                    flag: true,
                    message: 'Comments (Optional)',
                    success: true,
                    title: 'Submit Request'
                });
            } else {
                setModal({
                    flag: true,
                    success: false,
                    message: popMsg[0].blankField.description,
                    title: popMsg[0].blankField.heading
                });
            }
        }
    }

    const clearAll = () => {
        setError(false);
        setRelationError(false)
        let CountryCode = JSON.parse(JSON.stringify(EmpRequest.entity.CountryCode[0]));
        let RequestTo = EmpRequest?.RequestTo;
        let vendor = EmpRequest?.vendor;
        let Source = EmpRequest?.entity?.Source;
        setEmpRequest(classificationCode?.entity_type === 'HCP' ? CONSTANT.NEW_EMP_HCP_BODY : CONSTANT.NEW_EMP_HCO_BODY);
        RequestTo && vendor && setEmpRequest((oldvalue) => ({
            ...oldvalue,
            entity: {
                ...oldvalue.entity,
                Source: Source ? Source : [{ value: newSource }],
            },
            RequestTo: RequestTo,
            vendor: vendor}))
        setClear(true);
        updateValue(CountryCode, false, 'CountryCode')
        updateValue([],true,"Identifiers");//clear populated identifiers
        let intervalId = setTimeout(() => {
            setClear(false);
            clearTimeout(intervalId)
        }, 1000)
    }

    console.group('RENDER VALUES')
    console.log('formConfig', formConfig)
    console.log('EmpRequest', EmpRequest)
    console.log('validRequest', validRequest)
    console.log('requirefields', requirefields)
    console.log('invalidInput', invalidInput)
    console.groupEnd()

    return (
        <>
            {
                loading &&
                <div className="extra-margin-top d-flex justify-content-center body-height">
                    <ProgressBar />
                </div>
            }
            {
                !loading && errorMsg === undefined && showAllData && (
                    <>
                        <div className="extra-margin-top-less container w-80 body-height min-width">
                            <Stack
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                gap={1}
                            >
                                <Tooltip
                                    disableFocusListener
                                    title="Back"
                                    id="tltipStrictSearchChckbx"
                                >
                                    <IconButton
                                        aria-label="delete"
                                        onClick={goBack}
                                        className="text-danger float-end"
                                        color="secondary"
                                    >
                                        <ArrowBackIcon
                                            sx={{
                                                transform: direction === "rtl" ? "rotate(180deg)" : "",
                                            }}
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Typography
                                    variant="h1"
                                    margin={0}
                                    style={{ fontSize: 21 }}
                                    id="newhcp-text"
                                >
                                    {classificationCode?.value} Details
                                </Typography>
                            </Stack>
                            <>
                                <Card className="p-0 mb-3 mt-2">
                                    <IconButton
                                        aria-label="delete"
                                        onClick={openPopup}
                                        sx={{ float: "right", marginLeft: "30px" }}
                                    >
                                        <Tooltip
                                            disableFocusListener
                                            title="Edit details"
                                            id="tooltip"
                                        >
                                            <EditIcon
                                                sx={{
                                                    transform: direction === "rtl" ? "rotate(180deg)" : "",
                                                }}
                                            />
                                        </Tooltip>
                                    </IconButton>

                                    <CardContent className="p-2">
                                        <Stack
                                            direction="row"
                                            justifyContent={"space-around"}
                                            alignItems="center"
                                            flexWrap={"wrap"}
                                            className="p-0 m-0"
                                        >
                                            <Typography variant="p" margin={0} id="newhcp-text">
                                                <span className="text-muted">Country: </span>
                                                <span className="_wg-exclude">
                                                    {country}{" "}
                                                </span>
                                            </Typography>
                                            <Typography variant="p" margin={0} id="newhcp-text">
                                                <span className="text-muted">Source: </span>
                                                <span className="_wg-exclude">
                                                    {'Employer'}
                                                </span>
                                            </Typography>
                                            <Typography variant="p" margin={0} id="newhcp-text">
                                                <span className="text-muted">Classification Code: </span>
                                                <span className="_wg-exclude">
                                                    {classificationCode?.value}
                                                </span>
                                            </Typography>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </>
                            <>
                                <div>
                                    {formFields && formFields?.map((el, index) => {
                                        return (
                                            <>
                                                <Accordion
                                                    key={index}
                                                    className=' shadow-md'
                                                    expanded={accordianFlag[el.id]}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls='panel1a-content'
                                                        id={el.id}
                                                        onClick={() => closeAccordian(el.id)}
                                                    >
                                                        <Typography id='newemp-text' fontWeight="bold">{el.label}</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <div className='row container w-100 p-3 pt-0'>
                                                            {el?.attributes?.sort((a, b) => {
                                                                return a.order - b.order
                                                            })?.map((value, key) => {
                                                                // if (value.required) {
                                                                // requirefields.push(value.id)
                                                                // setRequireFields((old) => [...old, value.id])
                                                                // }
                                                                return (
                                                                    value.active === true && (
                                                                        <div key={key} className='col-sm-12 col-md-6 '>
                                                                            <span id='newhcp-text'>{value.name}</span>
                                                                            {value.required && (
                                                                                <span className='required-asterisk-exclusion'> *</span>
                                                                            )}
                                                                            <EmployerInput
                                                                                entity={formConfig?.entity}
                                                                                value=''
                                                                                label={value.name}
                                                                                type={value.element}
                                                                                pattern={value.pattern}
                                                                                formConfig={formFields}
                                                                                required={value.required}
                                                                                options={[]}
                                                                                updatedValue={(newValue, flag) => {
                                                                                    updateValue(newValue, flag, value.id)
                                                                                }}
                                                                                clear={clear}
                                                                                error={error}
                                                                                isEmployer={true}
                                                                                lovKey={classificationCode?.form_fields_key}
                                                                                invalidInput={invalidInput}
                                                                                setInvalidInput={setInvalidInput}
                                                                            // vendor={location.state.source ? location.state.source : newSource}
                                                                            // date={false}
                                                                            // newHCP={true}
                                                                            // newValue={filterdata}
                                                                            // require={value.required}
                                                                            // type={value.type}
                                                                            // value={''}
                                                                            // label={value.name}
                                                                            // countryName={EmpRequest.entity.CountryCode[0].value}
                                                                            // sourceName={EmpRequest.entity.Source[0].value}
                                                                            // entity={'HCP'}
                                                                            />
                                                                        </div>
                                                                    )
                                                                )
                                                            })}
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </>
                                        );
                                    })}

                                    {/* Identifiers */}
                                    {
                                        formConfig?.identifiers &&
                                        <>
                                            <IdentifiersView
                                                //    {...identifierviewparams}
                                                //     addFlag={"HCP"}
                                                clear={clear}
                                                mode={'Edit'}
                                                entity={classificationCode?.entity_type}
                                                // change={changeCompleted}
                                                error={showError}
                                                label={"Identifier"}
                                                // updatedValue={(newValue, flag) => { }}
                                                updatedValue={(newValue, flag) => { updateValue(newValue, flag, "Identifiers") }}
                                                heading={'Type&ID'}
                                                // value={[]}
                                                value={EmpRequest.entity.NewIdentifiers}
                                                checkIdentifierSubmitted={(addflag, identifierType, identifierId, identifierSaved) => { checkIdentifierSubmitted(addflag, identifierType, identifierId, identifierSaved) }}
                                                submit={identifierSubmit}
                                                shadow={true}
                                                vendor={'Employer'}
                                                isEmployer={true}
                                                lovKey={classificationCode?.form_fields_key}
                                                identifierOptions={EmployerConfig?.lov_config?.Identifier?.[classificationCode?.form_fields_key]}
                                            />
                                        </>
                                    }
                                </div>

                                {/* Relations */}
                                {
                                    formConfig?.relations &&
                                    <>
                                        <Accordion
                                            className="shadow-md"
                                            expanded={accordianFlag["relationInfo"]}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="FirstName"
                                                onClick={() => closeAccordian("relationInfo")}
                                            >
                                                <Typography id="newhcp-text" fontWeight="bold">Relation</Typography>
                                            </AccordionSummary>

                                            <AccordionDetails>

                                                {optionalRelation === "Optional" && !showRelation && (<div className=" container w-100 p-3 pt-0">
                                                    {
                                                        <Stack direction='row' alignItems='center'>
                                                            <IconButton size='small' sx={{ backgroundColor: 'var(--lilly-primary)', '&:hover': { background: 'var(--lilly-primary)', opacity: '0.6' } }} onClick={() => {
                                                                setShowRelation(true);
                                                                addOptional("Relation");
                                                            }}>
                                                                <Add sx={{ color: 'white' }} />
                                                            </IconButton>
                                                            <Typography marginLeft='10px' className='_wg-dynamic-text' variant='subtitle1'>Add Relation</Typography>
                                                        </Stack>

                                                    }
                                                </div>)}
                                                {showRelation && (<div className="w-100">
                                                    <NewRelation
                                                        clear={clear}
                                                        country={EmpRequest?.entity?.CountryCode[0]?.value}
                                                        source={newSource || 'Employer'}
                                                        // newHCP={classificationCode?.entity_type === 'HCP' ? true : false}
                                                        newHCP={true}
                                                        newData={formConfig?.["relation_fields"]}
                                                        relationshipTypeFields={formConfig?.affiliation_relationship_type}
                                                        error={relationError}
                                                        AddNewRelation={(newValue, flag) => {
                                                            updateValue(newValue, flag, 'Relation')
                                                        }}
                                                        showRelationType={true}
                                                        iqviaEnnable={false}
                                                        empQuery={formConfig?.empQuery}
                                                        isEmployer={true}
                                                        lovKey={classificationCode?.form_fields_key}
                                                        addOnlyExistingRelation={formConfig?.addOnlyExistingRelation}
                                                    />
                                                </div>)}

                                                {optionalRelation === "Optional" && showRelation && (
                                                    // <Link to='#' className='pointer' onClick={() => { setShowRelation(false); setCancel('Relation') }}><Cancel className="text-danger " /></Link>
                                                    <Stack direction={"row"} justifyContent={"flex-end"}>
                                                        <Button
                                                            sx={{
                                                                color: "gray",
                                                                "&:hover": { background: "rgba(134,136,138,0.05)" },
                                                            }}
                                                            size="small"
                                                            onClick={() => {
                                                                setShowRelation(false);
                                                                setCancel("Relation");
                                                            }}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </Stack>
                                                )}
                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                }
                            </>

                            {/* Dialog Actions */}
                            <>
                                <DialogActions
                                    className="d-flex justify-content-center mt-4 mb-3"
                                    id="newhcp-button"
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <Button
                                        className="btn btn-secondry border clearall"
                                        onClick={() => {
                                            clearAll();
                                        }}
                                        color="error"
                                        variant="outlined"
                                    >
                                        CLEAR ALL
                                    </Button>
                                    <Button
                                        className="btn btn-secondry border request"
                                        onClick={() => {
                                            submitRequest();
                                        }}
                                        color="error"
                                        variant="contained"
                                    >
                                        REQUEST
                                    </Button>
                                </DialogActions>
                            </>
                            {modal.flag && (
                                <PopupConfimation
                                    updateDetails={EmpRequest}
                                    closePopup={() => {
                                        setModal(false);
                                    }}
                                    open={modal.flag}
                                    success={modal.success}
                                    message={modal.message}
                                    title={modal.title}
                                    typeHCO={true}
                                    addNewHCO={true}
                                    flag={modal.flag}
                                    close={() => {
                                        setModal(false);
                                        goBack();
                                    }}
                                    source={newSource}
                                    isHcoWithoutRelation={EmpRequest?.relation ? false : true}
                                    isEmployer={true}
                                    isSbsRequired={true}
                                    entity={formConfig?.entity}
                                />
                            )}
                        </div>
                    </>
                )
            }
        </>
    )
}

export default AddNewEmployerForm;